<template>
  <section role="menu">
    <div>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="modalSescLabel">
              Credenciamento Prefeitura de Santos - SESC
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px">
              <div class="col-md-12 col-sm-12">
                <p style="text-align: justify">
                  Olá!<br /><br />

                  Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos
                  Municipal de Santos e ficará disponível para preenchimento a partir das
                  10h30 do 1º dia útil do mês (exceto segundas-feiras), por 48 horas, ou até
                  atingir o limite permitido no contrato, a saber, 300 inscrições/mês.
                  <br /><br />
                  <strong>Para acessar o link do formulário, faz-se necessário “atualizar os dados de
                    navegação”,</strong>
                  limpando o histórico de seu navegador, preferindo computadores ou notebook.
                  <br /><br />
                  Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,
                  a qual procederá com <strong>desconto único anual</strong> na folha de pagamento no valor
                  de R$40,00 (quarenta reais), referente ao credenciamento do titular.
                  <br /><br />
                  Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do
                  aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu
                  número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.
                  Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de
                  São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios
                  oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.
                  <br /><br />Para iniciarmos o processo de credenciamento MIS, tenha em
                  mãos seus documentos pessoais (RG, CPF e uma foto).

                <p>
                  <br />
                  Importante! <br /><br />
                  O não preenchimento dos dados, assim como o preenchimento incompleto,
                  serão considerados como inconsistência cadastral.
                  <br />
                  Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor
                  deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.
                </p>

                <br />
                <p>
                  <strong>Link do formulário eletrônico de inscrição para credenciamento dos servidores da
                    Prefeitura Municipal de Santos:</strong>
                </p>
                <br />
                <p>
                  <strong>Acesso:</strong>
                </p>
                <br />
                <a href="https://form.jotform.com/241063912551652">https://form.jotform.com/241063912551652</a></p>
                <br />
                <p>
                <p><strong>Manual para cadastramento no sistema do SESC, contendo perguntas e respostas
                    frequentes:</strong></p>
                <br />
                <a style="cursor: pointer" @click="baixaArquivo('manual_mis_sesc.pdf')">Acessar Manual</a>
                </p>
                <br /><br />
                <p>
                  <strong>
                    Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais
                    deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através
                    de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar
                    desde já):
                  </strong>
                </p>
                <br />
                <a style="cursor: pointer" @click="baixaArquivo('descontados-mes.pdf')">Acessar lista</a>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao estilo="cheio-verde" rotulo="Voltar" icone="voltar" @clicado="volta()"></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import Botao from '@/components/botao';
import FileHelper from '@/helpers/FileHelper';
export default {
  name: 'barra-menu',

  data() {
    return {
      funcionario: this.$store.state.funcionario,
      perfis: this.$store.state.usuarioLogado.perfis,
    };
  },
  methods: {
    modalSesc() {
      jQuery('#modalSesc').modal('show');
    },
    volta() {
      this.$router.push({ name: 'Home' });
    },
    baixaArquivo(arquivo) {
      FileHelper.download(arquivo, this);
    },
  },
  components: {
    Botao,
  },
  props: {
    rotas: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    declaracaoAtiva() {
      if (this.declaracaoVisitada) return 'active';
    },
    avaliacaoAtiva() {
      if (this.avaliacaoVisitada) return 'active';
    },
    recadastramentoAtiva() {
      if (this.recadastramentoVisitada) return 'active';
    },
    formulariosAtiva() {
      if (this.formulariosVisitada) return 'active';
    },
    feriasAtiva() {
      if (this.feriasVisitada) return 'active';
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
    },
    permissoes(novo, anterior) {
      this.perfis = novo;
    },
  },
};
</script>

<style scoped>
.navbar {
  margin-bottom: 0px;
  min-height: 53px;
  position: relative;
}

.navbar-default {
  background: #00615c none repeat scroll 0 0;
  border-color: #00615c;
  border-bottom: 1px solid #004f4a;
  color: #ffffff;
  border-radius: 0;
  margin-bottom: 20px;
  width: 100%;
  height: 53px;
  position: fixed;
  left: 0;
  top: 53px;
  z-index: 900;
}

.page-header-bg {
  overflow: hidden;
  position: relative;
  background: #00615c;
  margin-bottom: 20px;
  width: 100%;
  height: 53px;
}

.header-bg-cadastro {
  position: fixed;
  left: 0;
  top: 53px;
  border-bottom: 1px solid #004f4a;
}

ul {
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin: 0 0 2.2rem;
}

.nav>li {
  display: block;
  margin-top: 8px;
  position: relative;
}

.navbar-nav>li>a {
  border-radius: 0;
  color: #a1be4d;
  display: block;
  font-size: 0.85em;
  font-weight: bold;
  padding: 10px 15px;
  position: relative;
  text-transform: uppercase;
}

.navbar-nav>li>a.active,
.navbar-nav>li>a:focus,
.navbar-nav>li>a:hover,
.navbar-nav>li>a:visited {
  background-color: rgba(0, 0, 0, 0);
  border-bottom: 3px solid;
  text-decoration: none;
  border-radius: 0;
  color: #a1be4d;
  display: block;
  font-size: 0.85em;
  font-weight: bold;
  padding: 10px 15px;
  position: relative;
  text-transform: uppercase;
}

.dropdown-menu {
  font-size: 0.9em;
}

.navbar-default .navbar-nav>.open>a,
.navbar-default .navbar-nav>.open>a:hover,
.navbar-default .navbar-nav>.open>a:focus,
.navbar-default .navbar-nav>.open>a:active {
  background-color: rgba(0, 0, 0, 0);
  color: #a1be4d;
}

.dropdown-menu>li>a {
  color: #468b35;
}

.dropdown-menu>li>a:hover,
.dropdown-menu>li>a:focus {
  text-decoration: none;
  color: #a1be4d;
  background-color: #eefceb;
}

hr {
  margin: 5px 10px;
  border-color: #deecda;
}

@media screen and (min-width: 768px) {
  .navbar-default {
    background: #00615c none repeat scroll 0 0;
    border-color: #00615c;
    border-bottom: 1px solid #004f4a;
    color: #ffffff;
    border-radius: 0;
    margin-bottom: 20px;
    width: 100%;
    height: 53px;
    position: fixed;
    left: 0;
    top: 53px;
  }

  .page-header-bg {
    overflow: hidden;
    position: relative;
    background: #00615c;
    margin-bottom: 20px;
    width: 100%;
    height: 53px;
  }

  .header-bg-cadastro {
    position: fixed;
    left: 0;
    top: 53px;
    border-bottom: 1px solid #004f4a;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?4cd126f4